module.exports = __webpack_public_path__ + "static/media/28-2.c7b0a18c.mp3";